import{WordArray as o}from"./core.js";const s={pad(s,t){const c=4*t,e=c-s.sigBytes%c;s.concat(o.random(e-1)).concat(o.create([e<<24],1))},unpad(o){const s=o,t=255&s.words[s.sigBytes-1>>>2];s.sigBytes-=t}};export{s as Iso10126};
